import { render, staticRenderFns } from "./PayeeInfoInputFile.vue?vue&type=template&id=473b2068&scoped=true&"
import script from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoInputFile.vue?vue&type=style&index=0&id=473b2068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b2068",
  null
  
)

export default component.exports